import type { HomeIcon } from "@primer/octicons-react";
import { Link } from "react-router-dom";
import { Counter } from "./ui/badge";
import { TabLabel, UnderlineNav, UnderlineNavItem } from "./ui/tabs";

/** A menu entry; `current` marks the page shown, or for a tab, a page inside it. */
export type NavLeaf = { to: string; Icon: typeof HomeIcon; label: string; count?: number; current: boolean };
/** A tab, with the sub-pages its page lists in a side menu (RepoLayout). */
export type NavTab = NavLeaf & { items?: NavLeaf[] };

/** An organization's or repo's tabs, continuing the app header band; the current tab's sub-pages are a side menu beside the page. */
export function SubNav({ label, tabs }: { label: string; tabs: NavTab[] }) {
  return (
    <div className="border-b bg-header">
      <div className="px-6 max-md:px-4">
        <UnderlineNav aria-label={label}>
          {tabs.map((t) => (
            <UnderlineNavItem key={t.label} current={t.current}>
              <Link to={t.to}>
                <t.Icon size={16} /> <TabLabel>{t.label}</TabLabel> {t.count ? <Counter>{t.count}</Counter> : null}
              </Link>
            </UnderlineNavItem>
          ))}
        </UnderlineNav>
      </div>
    </div>
  );
}
